import React, { useEffect, useState } from "react";
import UserExpired from "../../../../services/UserServices/RestroUserStatExpired";
import { Card, CardBody, CardHeader } from "reactstrap";
import noDataFound from '../../../../assets/NoDataFound.mp4'
import { Link } from "react-router-dom";

const itemsPerPage = 5;

const ExpiredUsers = ({days}) => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const fetchData = async () => {
        try {
            const response = await UserExpired().getAll(days);
            setData(response || []);
            setCurrentPage(1);

        } catch (error) {
            console.error("Failed to fetch data: ", error);
        }
    };

    useEffect(() => {
        if (days) fetchData();
    }, [days]);

    console.log(data);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    return (
        <Card className=" flex-fill d-flex flex-column" style = {{height: "550px"}}>
            <CardHeader className="border-0 align-items-center d-flex">
                <h4 className="card-title mb-0 "> Expired Users</h4>
            </CardHeader>
            
                {data.length > 0 ? (
                    <CardBody>
                    <div
                        className="table-responsive"
                        style={{ minHeight: "300px", overflowY: "auto" }}
                    >
                        <table className="table table-hover table-centered align-middle table-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Valid Till</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedData.map((item, key) => (
                                    <tr key={key} className="align-middle py-4" >
                                        <td>
                                            <h5 className="fs-14 my-1">
                                                <Link to="#" className="text-reset text-wrap">
                                                    {item.tenantName}
                                                </Link>
                                            </h5>
                                        </td>
                                        <td className="d-flex align-items-center py-4">
                                            {/* <CountUp
                                                start={0}
                                                prefix={item.prefix}
                                                suffix={item.suffix}
                                                separator={item.separator}
                                                end={item.quantity}
                                                decimals={item.decimals}
                                                duration={2.5}
                                            /> */}
                                            <span className="text-muted ms-2">{item.phone}</span>
                                        </td>
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                
                                                <span className="text-muted ms-2">{item.validTill}</span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    </CardBody>
                ) : (
                    <div className="text-center" style={{ minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <video
                            src={noDataFound}
                            autoPlay
                            loop
                            muted
                            style={{ width: "300px", marginBottom: "20px", borderRadius: "10px" }}
                        />
                        <p className="text-muted">No expired users found.</p>
                    </div>

                )}


                {/* Pagination inside same container */}
                {data.length > itemsPerPage && (
                    <div className="d-flex align-items-center justify-content-between mt- ps-3 pb-3">
                        <div className="text-muted">
                            Showing{" "}
                            <span className="fw-semibold">
                                {startIndex + 1}-
                                {Math.min(startIndex + itemsPerPage, data.length)}
                            </span>{" "}
                            of <span className="fw-semibold">{data.length}</span> Results
                        </div>
                        <ul className="pagination pagination-separated pagination-sm mb-0 pe-3 pb-2">
                            <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                                <Link
                                    to="#"
                                    className="page-link"
                                    onClick={() =>
                                        currentPage > 1 && setCurrentPage(currentPage - 1)
                                    }
                                >
                                    ←
                                </Link>
                            </li>
                            {Array.from({ length: totalPages }, (_, idx) => (
                                <li
                                    key={idx}
                                    className={`page-item ${currentPage === idx + 1 && "active"}`}
                                >
                                    <Link
                                        to="#"
                                        className="page-link"
                                        onClick={() => setCurrentPage(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Link>
                                </li>
                            ))}
                            <li
                                className={`page-item ${currentPage === totalPages && "disabled"
                                    }`}
                            >
                                <Link
                                    to="#"
                                    className="page-link"
                                    onClick={() =>
                                        currentPage < totalPages && setCurrentPage(currentPage + 1)
                                    }
                                >
                                    →
                                </Link>
                            </li>
                        </ul>
                    </div>
                )}
            

        </Card>
    )

    // const columns = [
    //     {
    //         name: "Name",
    //         selector : (row) => row.tenantName,
    //         sortable: true,
    //     },
    //     {
    //         name: "Phone",
    //         width: "20%",
    //         wrap: true,
    //         sortable: true,
    //     }
    // ]
};

export default ExpiredUsers;